import type { StatusTone } from '@/shared/ui/status-badge'

export interface StatusMeta {
  label: string
  tone: StatusTone
}

const fallback: StatusMeta = { label: '—', tone: 'muted' }

const unitStatuses: Record<string, StatusMeta> = {
  creating: { label: 'Создаётся', tone: 'info' },
  bootstrapping: { label: 'Бутстрап', tone: 'info' },
  ready: { label: 'Готов', tone: 'ok' },
  draining: { label: 'Дренаж', tone: 'warn' },
  paused: { label: 'Пауза', tone: 'muted' },
  deleted: { label: 'Удалён', tone: 'muted' },
  error: { label: 'Ошибка', tone: 'danger' },
}

export function unitStatus(status: string): StatusMeta {
  return unitStatuses[status] ?? { ...fallback, label: status }
}

const cellStatuses: Record<string, StatusMeta> = {
  assembling: { label: 'Сборка', tone: 'info' },
  ready: { label: 'Готова', tone: 'ok' },
  draining: { label: 'Дренаж', tone: 'warn' },
  paused: { label: 'Пауза', tone: 'muted' },
  dismantled: { label: 'Разобрана', tone: 'muted' },
}

export function cellStatus(status: string): StatusMeta {
  return cellStatuses[status] ?? { ...fallback, label: status }
}

export const pauseSemanticsLabels: Record<string, string> = {
  'frees-gpu': 'Пауза освобождает GPU',
  billed: 'Пауза тарифицируется',
}

export function pauseSemanticsLabel(value: string): string {
  return pauseSemanticsLabels[value] ?? 'Не подтверждена'
}

export const unitClassLabels: Record<string, string> = {
  C: 'C · голосовой',
  L: 'L · языковой (LLM)',
}

export function unitClassLabel(cls: string): string {
  return unitClassLabels[cls.toUpperCase()] ?? cls
}
